/* import __COLOCATED_TEMPLATE__ from './group.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
var GroupCheckboxState = /*#__PURE__*/function (GroupCheckboxState) {
  GroupCheckboxState["Checked"] = "checked";
  GroupCheckboxState["Indeterminate"] = "indeterminate";
  GroupCheckboxState["Unchecked"] = "unchecked";
  return GroupCheckboxState;
}(GroupCheckboxState || {});
let FlyGroupedChecklistGroup = (_class = class FlyGroupedChecklistGroup extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "expanded", _descriptor, this);
  }
  get state() {
    let allChecked = this.items.filter(item => !item.disabled).every(item => this.args.selectedItems.includes(item.value));
    let someChecked = this.items.filter(item => !item.disabled).some(item => this.args.selectedItems.includes(item.value));
    if (allChecked) {
      return GroupCheckboxState.Checked;
    } else if (someChecked) {
      return GroupCheckboxState.Indeterminate;
    }
    return GroupCheckboxState.Unchecked;
  }
  get items() {
    return this.args.group.items.map(item => ({
      ...item,
      checked: this.args.selectedItems.includes(item.value)
    }));
  }
  get groupId() {
    return (Math.random() * 1000).toString().replace('.', '_');
  }
  handleExpandCollapse(evt, canClose = true) {
    evt.preventDefault();
    evt.stopPropagation();
    if ('key' in evt) {
      if (!['Enter', ' '].includes(evt.key) || evt.target.tagName !== 'DIV') {
        return;
      }
    }
    if (this.expanded && canClose) {
      this.expanded = false;
    } else {
      this.expanded = true;
      let [firstItem] = Array.from(evt.target.children);
      firstItem?.querySelector('input')?.focus();
    }
  }
  toggleGroup(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let {
      group
    } = this.args;
    let items = group.items.filter(item => !item.disabled).map(item => item.value);

    // onClick handler is on the label, so we need to check if the group is disabled first before
    // running the onChange handler
    if (this.args.disabled || group.disabled) {
      return;
    }
    if (this.state === GroupCheckboxState.Checked) {
      let newSelectedItems = this.args.selectedItems.filter(selectedItem => !items.includes(selectedItem));
      this.args.onChange({
        items,
        enabled: false,
        selectedItems: newSelectedItems
      });
    } else {
      // Quickly de-duplicate selected items by mashing two arrays together
      let newSelectedItems = new Set([...this.args.selectedItems, ...items]);
      this.args.onChange({
        items,
        enabled: true,
        selectedItems: Array.from(newSelectedItems)
      });
      this.handleExpandCollapse(evt, false);
    }
  }
  toggleItem(itemName, checked) {
    if (checked) {
      this.args.onChange({
        items: [itemName],
        enabled: checked,
        selectedItems: [...this.args.selectedItems, itemName]
      });
    } else {
      this.args.onChange({
        items: [itemName],
        enabled: checked,
        selectedItems: this.args.selectedItems.filter(selectedItem => selectedItem !== itemName)
      });
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "expanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleExpandCollapse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleExpandCollapse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleGroup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleItem"), _class.prototype)), _class);
export { FlyGroupedChecklistGroup as default };